class TopicsNavigation
    constructor: (el) ->
        @.$el = el
        
        @.firstTopicOpen = true
        @.topics = []

        @.PrepareElement()
        @.InitEvents()
        @.$el.classList.add 'topics-navigation--bound'
        return

    InitEvents: ->
        self = @
        @.topics.forEach (topic) ->
            topic.expandableMenusButtons.forEach (button) ->
                button.addEventListener 'click', (e) ->
                    e.preventDefault()
                    if @.classList.contains 'topics-navigation__topic__expandable-menus__button--active'
                        topic.expandableMenus[Object.values(topic.expandableMenusButtons).indexOf(button)].classList.remove 'topics-navigation__topic__expandable-menus__menu--active'
                        @.classList.remove 'topics-navigation__topic__expandable-menus__button--active'
                    else
                        activeButton = @.closest '.topics-navigation__topic'
                            .querySelector '.topics-navigation__topic__expandable-menus__button--active'
                        if activeButton
                            activeButton.classList.remove 'topics-navigation__topic__expandable-menus__button--active'
                        activeMenu = @.closest '.topics-navigation__topic'
                            .querySelector '.topics-navigation__topic__expandable-menus__menu--active'
                        if activeMenu
                            activeMenu.classList.remove 'topics-navigation__topic__expandable-menus__menu--active'
                        if !@.classList.contains 'topics-navigation__topic__expandable-menus__button--active'
                            topic.expandableMenus[Object.values(topic.expandableMenusButtons).indexOf(button)].classList.add 'topics-navigation__topic__expandable-menus__menu--active'
                            @.classList.add 'topics-navigation__topic__expandable-menus__button--active'
                    
        return

    PrepareElement: ->
        self = @
        @.$el.querySelectorAll '.topics-navigation__topic'
            .forEach (topicEl) ->
                topicEntry = {
                    expandableMenus: topicEl.querySelectorAll '.topics-navigation__topic__expandable-menus__menu'
                    expandableMenusButtons: topicEl.querySelectorAll '.topics-navigation__topic__expandable-menus__button'
                }
                if topicEntry.expandableMenusButtons.length > 0
                    if self.firstTopicOpen
                        topicEntry.expandableMenusButtons[0].classList.add 'topics-navigation__topic__expandable-menus__button--active'
                        topicEntry.expandableMenus[0].classList.add 'topics-navigation__topic__expandable-menus__menu--active'
                    for menuElement, index in topicEntry.expandableMenus
                        topicEntry.expandableMenusButtons[index].parentNode.querySelector '.topics-navigation__topic__expandable-menus__menu-mobile'
                            .innerHTML = menuElement.innerHTML
                self.topics.push topicEntry
                return
        return

BindTopicsNavigations = ->
    document.querySelectorAll '.topics-navigation:not(.topics-navigation--bound)'
        .forEach (el) ->
            new TopicsNavigation el
            return
    return

window.addEventListener 'bind-components', BindTopicsNavigations